module.exports = __webpack_public_path__ + "static/media/img18.159b4756.png";